// api/api.js

const HOSTNAME = 'https://portfolio.waithakasam.com';
const API_URL = `${HOSTNAME}/api/v1`;
const DATA_SOURCE = process.env.REACT_APP_DATA_SOURCE || 'local';

// Function to fetch data based on environment
export const fetchData = async (endpoint) => {
    if (DATA_SOURCE === 'local') {
        // Use local files
        return await fetchLocalData(endpoint);
    } else {
        // Use API
        return await fetchApiData(endpoint);
    }
};

// Function to fetch from API
const fetchApiData = async (endpoint) => {
    try {
        const response = await fetch(`${API_URL}${endpoint}`);
        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching API data:', error);
        throw error;
    }
};

// Function to fetch from local files
const fetchLocalData = async (endpoint) => {
    try {
        let filePath;

        if (endpoint === '/projects') {
            filePath = '/output/data/projects.json';
        } else if (endpoint.startsWith('/projects/')) {
            const projectId = endpoint.split('/projects/')[1];
            filePath = `/output/data/${projectId}.json`;
        } else {
            throw new Error(`Unsupported local endpoint: ${endpoint}`);
        }

        const response = await fetch(filePath);
        if (!response.ok) {
            throw new Error(`Failed to load local file: ${filePath}`);
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching local data:', error);
        throw error;
    }
};

// Function to get media URL based on data source
export const getMediaUrl = (mediaPath) => {
    if (!mediaPath) return '';

    if (DATA_SOURCE === 'local') {
        // For local files, extract just the filename and point to local media folder
        let filename;

        if (mediaPath.startsWith('static/uploads/')) {
            filename = mediaPath.split('static/uploads/')[1];
        } else if (mediaPath.startsWith('api/v1/static/uploads/')) {
            filename = mediaPath.split('api/v1/static/uploads/')[1];
        } else if (mediaPath.startsWith('uploads/')) {
            filename = mediaPath.split('uploads/')[1];
        } else {
            // If it's just a filename
            filename = mediaPath.split('/').pop();
        }

        return `/output/media/${filename}`;
    } else {
        // For API, use the original logic
        return `${HOSTNAME}/api/v1/static/${mediaPath}`;
    }
};

// Function to check current data source
export const getDataSource = () => DATA_SOURCE;

// Export HOSTNAME for backward compatibility
export { HOSTNAME };